import React from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Stack, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import styledComponent from 'styled-components';

export const MiscFurnitureDesc = ({ isModEdit }) => {
  const { t } = useTranslation();
  const { control, getValues } = useFormContext();
  return (
    <Grid>
      <Grid item xs={12}>
        <Controller
          name="furnitureNotes"
          control={control}
          render={({ field: { onChange, value, ...rest } }) => (
            <Stack>
              <TextField
                value={getValues('furnitureNotes')}
                multiline={true}
                maxRows={5}
                InputLabelProps={{
                  shrink: getValues('furnitureNotes') ?? false,
                }}
                inputProps={{
                  maxLength: 1000,
                }}
                variant="filled"
                label={t(`placement.placementMods.miscFurnitureDesc`)}
                InputProps={{
                  readOnly: !isModEdit,
                  style: {
                    pointerEvents: 'auto',
                    overflowY: 'auto'
                  },
                  sx: { fontSize: '14px' },
                }}
                {...rest}
              />
              <DescriptionCountStyle>{`${
                getValues('furnitureNotes')?.length ? getValues('furnitureNotes')?.length : 0
              }/1,000`}</DescriptionCountStyle>
            </Stack>
          )}
        />
      </Grid>
    </Grid>
  );
};

const DescriptionCountStyle = styledComponent.div`
display: flex;
justify-content: flex-end;
font-size: 10px;
`;
